import Button from '@rio-cloud/rio-uikit/Button';
import ButtonToolbar from '@rio-cloud/rio-uikit/ButtonToolbar';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { TransportAssignmentBulkUpdatePreviewResult } from '../transportAssignment.types';
import { TransportOrderBulkUpdateFormStep } from './TransportOrderBulkUpdateFormStep';
import { TransportOrderBulkUpdateValidationFeedback } from './TransportOrderBulkUpdateValidationFeedback';
import { useAppDispatch } from '../../../../configuration/setup/hooks';
import { transportAssignmentsSlice } from '../../reducers/transportAssignmentsSlice';

type TransportOrderBulkUpdateDialogProps = {
    readonly previewResult: TransportAssignmentBulkUpdatePreviewResult;
    readonly onClose: () => void;
};

enum TransportOrderBulkUpdateDialogStep {
    VALIDATION = 'validation',
    FORM = 'form',
}

export const TransportOrderBulkUpdateDialog = ({ previewResult, onClose }: TransportOrderBulkUpdateDialogProps) => {
    const dispatch = useAppDispatch();
    const [currentStep, setCurrentStep] = useState(TransportOrderBulkUpdateDialogStep.VALIDATION);
    const isValidationStep = currentStep === TransportOrderBulkUpdateDialogStep.VALIDATION;
    const nextButtonDisabled = !previewResult.success || previewResult.assignments.length === 0;
    const closeButtonLabel = isValidationStep
        ? 'outboundOrderBook.common.button.cancel'
        : 'outboundOrderBook.common.button.done';

    const handleOnClose = () => {
        if (!isValidationStep) {
            dispatch(transportAssignmentsSlice.actions.clearBulkSelection());
        }
        onClose();
    };

    return (
        <Dialog show onClose={onClose} showCloseButton bsSize={Dialog.SIZE_LG}>
            <Dialog.Title
                title={<FormattedMessage id="outboundOrderBook.transportAssignments.bulkUpdate.dialogTitle" />}
            />
            <Dialog.Body>
                {isValidationStep ? (
                    <TransportOrderBulkUpdateValidationFeedback previewResult={previewResult} />
                ) : (
                    previewResult.success && (
                        <TransportOrderBulkUpdateFormStep validAssignments={previewResult.assignments} />
                    )
                )}
            </Dialog.Body>
            <Dialog.Footer>
                <ButtonToolbar>
                    <Button iconName={isValidationStep ? undefined : 'rioglyph rioglyph-ok'} onClick={handleOnClose}>
                        <FormattedMessage id={closeButtonLabel} />
                    </Button>
                    {isValidationStep && (
                        <Button
                            bsStyle={Button.PRIMARY}
                            onClick={() => setCurrentStep(TransportOrderBulkUpdateDialogStep.FORM)}
                            disabled={nextButtonDisabled}
                        >
                            <FormattedMessage id="outboundOrderBook.common.button.next" />
                        </Button>
                    )}
                </ButtonToolbar>
            </Dialog.Footer>
        </Dialog>
    );
};
